const state = {
  editing: null,
};

const actions = {
  setLayerEditing(context, payload) {
    context.commit('SET_LAYER_EDITING', payload);
  },

  clearLayerEditing(context) {
    context.commit('CLEAR_LAYER_EDITING');
  },
};

const mutations = {
  /* eslint-disable no-shadow, no-param-reassign */

  SET_LAYER_EDITING(state, payload) {
    state.editing = payload;
  },

  CLEAR_LAYER_EDITING(state) {
    state.editing = null;
  },
};

export default {
  state,
  actions,
  mutations,
};
